const RHEMAS = [{"rhema": "아브람이 여호와를 믿었습니다.\n그래서 여호와께서 아브람의 그런 믿음 때문에\n그를 의롭게 여기셨습니다.", "address": "창 15:6"},
    {"rhema": "여호와께서 너희를 위해 싸우실 것이니\n너희는 그저 가만히 있기만 하면 된다.", "address": "출 14:14"},
    {"rhema": "그러나 거기서 너희가 너희 하나님 여호와를 바라고\n너희 온 마음과 온 영혼으로 찾으면\n너희는 그분을 만나게 될 것이다.", "address": "신 4:29"},
    {"rhema": "이스라엘아, 들으라.\n우리 하나님 여호와는 오직 한 분인 여호와이시다.\n너는 네 온 마음을 다하고\n영혼을 다하고 힘을 다해서\n네 하나님 여호와를 사랑하여라.", "address": "신 6:4-5"},
    {"rhema": "그러므로 너희 하나님 여호와께서\n하나님이심을 알라.\n그분은 주를 사랑하고\n주의 명령을 지키는 사람들에게는\n그분의 사랑의 언약을 천대까지 지키시는\n믿음직하고 좋은 하나님이시다.", "address": "신 7:9"},
    {"rhema": "강하고 담대하라.\n그들을 두려워하거나 무서워하지 말라.\n그분께서는 너희와 함께하실 하나님 여호와이시니\n그분이 너희를 떠나지도, 버리지도 않으실 것이다.", "address": "신 31:6"},
    {"rhema": "내가 네게 명령하지 않았느냐?\n강하고 담대하여라. 두려워하지 말고 낙심하지 마라.\n네가 어디를 가든 여호와 네 하나님이\n너와 함께할 것이다.", "address": "수 1:9"},
    {"rhema": "또한 여호와께서는\n칼이나 창으로 구원하지 않으신다는 것을\n여기 모인 사람들이 다 알게 될 것이다.\n전쟁은 여호와께 속한 것이니\n그분이 너희 모두를\n우리 손에 넘겨주실 것이다.", "address": "삼상 17:47"},
    {"rhema": "여호와는 나의 목자이시니\n내게 부족한 것이 없습니다.", "address": "시 23:1"},
    {"rhema": "내가 죽음의 그림자가 드리운\n골짜기를 지날 때라도\n악한 것을 두려워하지 않는 이유는\n주께서 나와 함께 계시기 때문입니다.\n주의 지팡이와 막대기가\n나를 지키시고 보호하십니다.", "address": "시 23:4"},
    {"rhema": "여호와는 내 빛이시요, 내 구원이시니\n내가 무엇을 두려워하겠습니까?\n여호와는 내 삶의 힘이시니\n내가 누구를 무서워하겠습니까?", "address": "시 27:1"},
    {"rhema": "당신의 길을 여호와께 맡기십시오.\n또 그분을 신뢰하십시오.\n그러면 그분이 이루어 주실 것입니다.","address": "시 37:5"},
    {"rhema": "\"차분히 생각해 내가 하나님임을 알라.\n내가 이방 민족들 가운데서 높임을 받고\n내가 땅에서 높임을 받으리라.\"","address": "시 46:10"},
    {"rhema": "여호와께서 내 편이시니\n내가 두려워하지 않겠습니다.\n사람이 내게 어떻게 하겠습니까?","address": "시 118:6"},
    {"rhema": "내가 주의 모든 계명을 깊이 되새기면\n수치당할 일이 없을 것입니다.","address": "시 119:6"},
    {"rhema": "주의 말씀은 내 발의 등불이요,\n내 길의 빛입니다.","address": "시 119:105"},
    {"rhema": "내가 주의 의로운 법을 따르기로 맹세했으니\n그렇게 할 것입니다.","address": "시 119:106"},
    {"rhema": "주께서 내게 응답하시고\n내 구원이 되셨으니\n내가 주를 찬양하겠습니다.","address": "시 118:21"},
    {"rhema": "네 마음을 다해 여호와를 믿고\n네 지식을 의지하지 마라.","address": "잠 3:5"},
    {"rhema": "네가 하는 모든 일에서 그분을 인정하여라.\n그러면 그분이 네 갈 길을 알려 줄 것이다.","address": "잠 3:6"},
    {
        "rhema": "네가 하는 일을 여호와께 맡겨라.\n그러면 네가 생각하는 것이 이루어질 것이다.",
        "address": "잠 16:3"
    },
    {
        "rhema": "여호와의 이름은 견고한 망대이니\n의인이 거기로 달려가면 안전하다.",
        "address": "잠 18:10"
    },
    {
        "rhema": "사람을 두려워하면 덫에 걸리지만\n여호와를 의지하는 사람은 누구나 안전하다.",
        "address": "잠 29:25"
    },
    {
        "rhema": "'주를 한결같은 마음으로 의지하는 사람들에게\n주께서 평화를 넘치도록 부어 주십시오.\n그가 주님을 신뢰하기 때문입니다.'",
        "address": "사 26:3"
    },
    {
        "rhema": "여호와를 바라는 사람들은 새로운 힘을 얻을 것이다.\n독수리가 날개를 치면서 솟구치듯 올라갈 것이고\n아무리 달려도 지치지 않고\n아무리 걸어도 피곤하지 않을 것이다.",
        "address": "사 40:31"
    },
    {
        "rhema": "그러니 두려워하지 마라. 내가 너와 함께 있다.\n걱정하지 마라. 나는 네 하나님이다.\n내가 너를 강하게 하고 너를 도와주겠다.\n내 의로운 오른손으로 너를 붙들어 주겠다.",
        "address": "사 41:10"
    },
    {
        "rhema": "네가 바다를 건널 때 내가 너와 함께하겠고\n네가 강을 건널 때 휩쓸려 가지 않을 것이다.\n네가 불 속을 걸어갈 때 타지 않을 것이고\n불꽃이 네 몸을 태우지 못할 것이다.",
        "address": "사 43:2"
    },
    {
        "rhema": "그러나 여호와를 의지하고\n여호와를 신뢰하는 사람은 복을 받을 것이다.",
        "address": "렘 17:7"
    },
    {
        "rhema": "여호와의 말이다.\n내가 너희를 위해 갖고 있는 계획들을 내가 알고 있으니\n그것은 평안을 위한 계획이지 재앙을 위한 것이 아니며\n너희에게 미래와 소망을 주기 위한 것이다.",
        "address": "렘 29:11"
    },
    {
        "rhema": "'내게 부르짖어라. 그러면 내가 네게 대답하겠고\n네가 알지 못하는 크고 비밀스러운 일들을\n네게 알려 줄 것이다.'",
        "address": "렘 33:3"
    },
    {
      "rhema": "만약 우리가 절하지 않을 경우\n우리가 섬기는 하나님께서\n우리를 활활 타는 불구덩이 속에서 구해 주실 것입니다.\n그분이 우리를 왕의 손에서 구해 내실 것입니다.",
      "address": "단 3:17"
    },
    {
      "rhema": "다니엘을 사자 굴 속에서 꺼내 살펴보니\n몸에 상처 하나 입지 않았습니다.\n이것은 그가 자기 하나님을 믿었기 때문이었습니다.",
      "address": "단 6:23 하"
    },
    {
      "rhema": "보아라.\n마음이 교만한 사람은 의롭지 않다.\n그러나 의인은 그의 믿음으로 살 것이다.",
      "address": "합 2:4"
    },
    {
      "rhema": "무화과나무가 싹이 트지 않고\n포도나무에 열매가 없다고 해도,\n올리브 나무에서 수확할 것이 없고\n밭은 먹을 것을 생산하지 못해도,\n우리 안에 양 떼가 없고\n외양간에 소가 없다 해도,",
      "address": "합 3:17"
    },
    {
      "rhema": "나는 여호와를 기뻐할 것이고\n나의 구원이 되시는 하나님을 즐거워할 것입니다.",
      "address": "합 3:18"
    },
    {
      "rhema": "오 사람아, 무엇이 좋은지\n이미 그분께서 네게 말씀하셨다.\n여호와께서 네게 원하시는 것은\n공의에 맞게 행동하고\n긍휼을 사랑하며\n겸손히 네 하나님과 함께 행하는 것이다.",
      "address": "미 6:8"
    },
    {
      "rhema": "'네 힘으로도 안 되고\n네 능력으로도 안 되고\n오직 내 영으로만 된다.’",
      "address": "슥 4:6"
    },
    {
      "rhema": "오직 너희는\n먼저 그 나라와 그 의를 구하라.\n그러면 이 모든 것도 너희에게 더해 주실 것이다.",
      "address": "마 6:33"
    },
    {
      "rhema": "구하라. 그러면 너희에게 주실 것이다.\n찾으라. 그러면 너희가 찾을 것이다.\n문을 두드리라. 그러면 너희에게 문이 열릴 것이다.",
      "address": "마 7:7"
    },
    {
      "rhema": "구하는 사람마다 받을 것이며\n찾는 사람이 찾을 것이며\n두드리는 사람에게 문이 열릴 것이다.",
      "address": "마 7:8"
    },
    {
        "rhema": "그러자 예수께서는\n그들의 눈을 만지시며 말씀하셨습니다.\n\"너희 믿음대로 되라.\"",
        "address": "마 9:29"
    },
    {
        "rhema": "\"수고하고 무거운 짐을 진 모든 사람은 다 내게로 오라.\n내가 너희를 쉬게 할 것이다.\"",
        "address": "마 11:28"
    },
    {
        "rhema": "“내가 진실로 너희에게 말한다.\n너희에게 겨자씨 한 알만 한 믿음만 있어도\n이 산을 향해\n'여기서 저기로 옮겨 가거라' 하면 옮겨 갈 것이요,\n너희가 못할 일이 없을 것이다.\"",
        "address": "마 17:20 하"
    },
    {
        "rhema": "너희가 기도할 때\n무엇이든지 믿고 구하는 것은 다 받을 것이다.",
        "address": "마 21:22"
    },
    {
        "rhema": "예수께서 말씀하셨습니다.\n\"'하실 수 있다면'이 무슨 말이냐?\n믿는 사람에게는 모든 일이 가능하다.\"",
        "address": "막 9:23"
    },
    {
        "rhema": "그러므로 내가 너희에게 말한다.\n무엇이든지 너희가 기도하고 간구하는 것은\n이미 받은 줄로 믿으라.\n그러면 너희에게 그대로 이루어질 것이다.",
        "address": "막 11:24"
    },
    {
        "rhema": "하나님께는 불가능한 일이 전혀 없다.",
        "address": "눅 1:37"
    },
    {
        "rhema": "남에게 주라. 그러면 너희가 받을 것이다.\n그것도 많이 꾹꾹 눌러 흔들어서\n넘치도록 너희 품에 안겨 줄 것이다.\n너희가 남을 저울질하는 만큼 너희도 저울질당할 것이다.",
        "address": "눅 6:38"
    },
    {
        "rhema": "사도들이 주께 말했습니다.\n\"우리에게 믿음을 더해 주십시오!\"",
        "address": "눅 17:5"
    },
    {
        "rhema": "예수께서 말씀하셨습니다.\n\"너희 믿음이 이 겨자씨 한 알 만큼만 있어도\n이 뽕나무에게 '뿌리째 뽑혀 바다에 심겨라!'라고 하면\n그 나무가 너희에게 순종할 것이다.\"",
        "address": "눅 17:6"
    },
    {
      "rhema": "하나님께서 세상을 이처럼 사랑하셔서\n독생자를 주셨으니\n이는 그를 믿는 사람마다 멸망하지 않고\n영생을 얻게 하려는 것이다.",
      "address": "요 3:16"
    },
    {
      "rhema": "\"너희는 마음에 근심하지 말라.\n하나님을 믿고 또 나를 믿으라.\"",
      "address": "요 14:1"
    },
    {
      "rhema": "나는 포도나무요, 너희는 가지다.\n그가 내 안에 있고 내가 그 안에 있으면\n그 사람은 많은 열매를 맺는다.\n나를 떠나서는 너희가 아무것도 할 수 없다.",
      "address": "요 15:5"
    },
    {
      "rhema": "내가 너희에게 이런 것들을 말하는 것은\n너희가 내 안에서 평안을 누리게 하려는 것이다.\n너희가 이 세상에서는 고난을 당할 것이다.\n그러나 담대하라. 내가 세상을 이미 이겼다.\"",
      "address": "요 16:33"
    },
    {
      "rhema": "그러자 예수께서 도마에게 말씀하셨습니다.\n\"너는 나를 보았기 때문에 믿느냐?\n보지 않고도 믿는 사람은 복이 있다.\"",
      "address": "요 20:29"
    },
    {
      "rhema": "예수 외에 다른 어느 누구에게서도\n구원을 받을 수 없습니다.\n하나님께서는 하늘 아래 우리가 구원받을 만한\n다른 이름을 우리에게 주신 일이 없기 때문입니다.\"",
      "address": "행 4:12"
    },
    {
      "rhema": "그들이 대답했습니다.\n\"주 예수를 믿으시오.\n그러면 당신과 당신의 집안이 구원을 받을 것입니다.\"",
      "address": "행 16:31"
    },
    {
      "rhema": "복음에는 하나님의 의가 계시돼\n믿음으로부터 믿음에 이르게 합니다.\n기록되기를 \"의인은 믿음으로 살 것이다\"\n라고 한 것과 같습니다.",
      "address": "롬 1:17"
    },
    {
      "rhema": "그는 하나님의 약속을 믿고 의심하지 않았고\n도리어 믿음이 굳건해져서 하나님께 영광을 돌리고\n약속하신 그것을 또한 능히 이루실 것을 확신했습니다.",
      "address": "롬 4:20-21"
    },
    {
      "rhema": "그러므로 우리는 믿음으로 의롭다는 인정을 받아\n우리 주 예수 그리스도로 인해\n하나님과 더불어 화평을 누리고 있습니다.",
      "address": "롬 5:1"
    },
    {
      "rhema": "우리는 하나님을 사랑하는 사람들,\n곧 그분의 뜻을 따라 부르심을 받은 사람들에게는\n모든 것이 합력해 선을 이루는 줄을 압니다.",
      "address": "롬 8:28"
    },
    {
      "rhema": "\"주의 이름을 부르는 사람은\n누구든지 구원을 받을 것이다.\"",
      "address": "롬 10:13"
    },
    {
      "rhema": "여러분은 이 세대를 본받지 말고\n오직 마음을 새롭게 함으로 변화를 받아\n하나님의 선하시고 기뻐하시고\n온전하신 뜻이 무엇인지 분별하도록 하십시오.",
      "address": "롬 12:2"
    },
    {
      "rhema": "우리는 살아도 주를 위해 살고\n죽어도 주를 위해 죽습니다.\n그러므로 죽든지 살든지 우리는 주의 것입니다.",
      "address": "롬 14:8"
    },
    {
      "rhema": "그러므로 내 사랑하는 형제들이여,\n굳게 서서 흔들리지 마십시오.\n여러분의 수고가 주 안에서 헛되지 않음을 알고\n항상 주의 일에 더욱 힘쓰는 사람들이 되십시오.",
      "address": "고전 15:58"
    },
    {
      "rhema": "우리는 믿음으로 행하고\n보는 것으로 행하지 않습니다.",
      "address": "고후 5:7"
    },
    {
      "rhema": "그러므로 나는 내 약한 것들에 대해\n크게 기뻐하며 자랑할 것입니다.\n이는 그리스도의 능력이 내게 머물게 하기 위함입니다.",
      "address": "고후 12:9 하"
    },
    {
      "rhema": "나는 그리스도와 함께 십자가에 못 박혔습니다.\n그러므로 이제 더 이상 내가 사는 것이 아니라\n내 안에 그리스도께서 사시는 것입니다.\n지금 내가 육체 안에 사는 것은\n나를 사랑하셔서 나를 위해\n자신의 몸을 내 주신 하나님의 아들을 믿는\n믿음으로 사는 것입니다.",
      "address": "갈 2:20"
    },
    {
      "rhema": "여러분은 은혜로 인해 믿음으로 구원받았습니다.\n이것은 여러분에게서 나온 것이 아니요,\n하나님의 선물입니다.",
      "address": "엡 2:8"
    },
    {
      "rhema": "마지막으로 여러분은 주 안에서\n그리고 주의 힘의 능력으로 강건해지십시오.\n마귀의 계략에 대적해 설 수 있도록\n하나님의 전신 갑주를 입으십시오.",
      "address": "엡 6:10-11"
    },
    {
      "rhema": "아무것도 염려하지 말고\n오직 모든 일에 기도와 간구로\n여러분이 구할 것을 하나님께 감사함으로 아뢰십시오.\n그리하면 모든 생각을 뛰어넘는 하나님의 평강이\n그리스도 예수 안에서\n여러분의 마음과 생각을 지켜 주실 것입니다.",
      "address": "빌 4:6-7"
    },
    {
      "rhema": "내게 능력 주시는 분 안에서\n내가 모든 일을 감당할 수 있습니다.",
      "address": "빌 4:13"
    },
    {
      "rhema": "내 하나님께서 그리스도 예수 안에서\n영광 가운데 그분의 풍성하심을 따라\n여러분의 모든 필요를 채워 주실 것입니다.",
      "address": "빌 4:19"
    },
    {
      "rhema": "그러므로 여러분은\n그리스도 예수를 주로 영접한 것처럼\n주 안에서 사십시오.",
      "address": "골 2:6"
    },
    {
      "rhema": "여러분은 주 안에 뿌리를 내리고 세움을 받으며\n가르침을 받은 대로 믿음 안에 굳게 서서\n감사가 넘치게 하십시오.",
      "address": "골 2:7"
    },
    {
      "rhema": "위에 있는 것들을 생각하고\n땅에 있는 것들을 생각하지 마십시오.",
      "address": "골 3:2"
    },
    {
      "rhema": "무슨 일을 하든지\n사람에게 하듯 하지 말고\n주께 하듯 마음을 다해 하십시오.",
      "address": "골 3:23"
    },
    {
      "rhema": "항상 기뻐하십시오.\n쉬지 말고 기도하십시오.\n모든 일에 감사하십시오.\n이는 그리스도 예수 안에서\n여러분을 향하신 하나님의 뜻입니다.",
      "address": "살전 5:16-18"
    },
    {
      "rhema": "우리 주의 은혜가\n그리스도 예수 안에 있는 믿음과 사랑과 함께\n넘치도록 풍성했다.",
      "address": "딤전 1:14"
    },
    {
      "rhema": "하나님께서 우리에게 주신 것은\n두려움의 영이 아니라\n능력과 사랑과 절제의 영이다.",
      "address": "딤후 1:7"
    },
    {
      "rhema": "너는 말씀을 전파하여라.\n때를 얻든지 못 얻든지 항상 힘써라.\n끝까지 오래 참고 가르치며\n책망하고 경계하고 권면하여라.",
      "address": "딤후 4:2"
    },
    {
      "rhema": "그러므로 함께 하늘의 부르심을 받은\n거룩한 형제 여러분,\n우리가 고백하는 사도이시며\n대제사장이신 예수를 깊이 생각하십시오.",
      "address": "히 3:1"
    },
    {
      "rhema": "우리가 고백하는 소망의 믿음을 단단히 붙잡읍시다.\n이는 약속하신 분이 신실하시기 때문입니다.",
      "address": "히 10:23"
    },
    {
      "rhema": "믿음은 바라는 것들의 실체이며\n보지 못하는 것들의 증거입니다.",
      "address": "히 11:1"
    },
    {
      "rhema": "믿음이 없이는 하나님을 기쁘시게 할 수 없습니다.\n그러므로 하나님께 나아가는 사람은\n하나님이 계신 것과\n하나님은 그분을 간절히 찾는 사람들에게\n상 주시는 분임을 믿어야 합니다.",
      "address": "히 11:6"
    },
    {
      "rhema": "이와 같이 우리를 둘러싼\n구름같이 많은 증인들이 있으니\n모든 짐과 얽매이기 쉬운 죄를 벗어 버리고\n인내로써 우리 앞에 놓인 경주를 합시다.",
      "address": "히 12:1"
    },
    {
      "rhema": "예수 그리스도께서는\n어제나 오늘이나 영원토록 한결같으신 분입니다.",
      "address": "히 13:8"
    },
    {
      "rhema": "당신이 알다시피\n믿음이 그의 행함과 함께 일하고\n행함으로 믿음이 온전하게 된 것입니다.",
      "address": "약 2:22"
    },
    {
      "rhema": "하나님을 가까이하십시오.\n그러면 하나님께서 여러분에게 가까이 오실 것입니다.",
      "address": "약 4:8 상"
    },
    {
      "rhema": "믿음의 기도는 병든 사람을 낫게 할 것이며\n주께서 그를 일으키실 것입니다.\n비록 그가 죄를 지었을지라도 용서받을 것입니다.",
      "address": "약 5:15"
    },
    {
      "rhema": "여러분은 마지막 때 나타내려고\n예비하신 구원을 얻기 위해\n믿음으로 인해 하나님의 능력으로\n보호하심을 받고 있습니다.",
      "address": "벧전 1:5"
    },
    {
      "rhema": "그것은 여러분이 당하는 믿음의 시련이\n불로 단련해도 없어질 금보다 더 귀해\n예수 그리스도께서 나타나실 때\n칭찬과 영광과 존귀를 얻게 하려는 것입니다.",
      "address": "벧전 1:7"
    },
    {
      "rhema": "여러분은 그리스도를 보지 못했으나 사랑합니다.\n지금도 여러분은 그분을 보지 못하지만 믿고,\n말할 수 없는 영광스러운 기쁨으로 즐거워합니다.",
      "address": "벧전 1:8"
    },
    {
      "rhema": "성경에 기록되기를\n\"보라. 내가 택한 보배롭고\n요긴한 모퉁잇돌을 시온에 둔다.\n그를 믿는 사람은 결코 수치를 당하지 않을 것이다\"\n라고 했습니다.",
      "address": "벧전 2:6"
    },
    {
      "rhema": "여러분의 모든 근심을 주께 맡기십시오.\n주께서 여러분을 돌보십니다.",
      "address": "벧전 5:7"
    },
    {
      "rhema": "그러면 모든 은혜의 하나님,\n곧 그리스도 예수 안에서 여러분을\n그분의 영원한 영광 가운데로 부르신 분이\n잠시 고난받는 여러분을 친히 온전하게 하시고\n굳건히 세우시고 강하게 하시고 견고하게 하실 것입니다.",
      "address": "벧전 5:10"
    },
    {
      "rhema": "그러므로 형제들이여,\n더욱 힘써 여러분의 부르심과 택하심을 굳건히 하십시오.\n여러분이 이것들을 행하면 결코 넘어지지 않을 것입니다.",
      "address": "벧후 1:10"
    },
    {
      "rhema": "하나님의 계명은 이것이니,\n곧 하나님의 아들 예수 그리스도의 이름을 믿고\n하나님께서 우리에게 계명을 주신 대로\n서로 사랑하라는 것입니다.",
      "address": "요일 3:23"
    },
    {
      "rhema": "하나님에게서 난 사람은 누구나 세상을 이깁니다.\n세상을 이긴 이김은 이것이니 바로 우리의 믿음입니다.",
      "address": "요일 5:4"
    },
    {
      "rhema": "세상을 이긴 사람이 누구입니까?\n예수께서 하나님의 아들이심을 믿는 사람이 아닙니까?",
      "address": "요일 5:5"
    },
    {
      "rhema": "하나님을 향해 우리가 갖는 확신은 이것입니다.\n곧 무엇이든지 우리가 그분의 뜻을 따라 구하면\n하나님께서 우리가 구하는 것을 들으신다는 것입니다.",
      "address": "요일 5:14"
    },
    {
      "rhema": "그리고 우리가 무엇을 구하든지\n하나님께서 들으시는 것을 알면\n우리는 우리가 구한 것들을\n그분으로부터 받는다는 것도 압니다.",
      "address": "요일 5:15"
    },
    {
      "rhema": "성도들의 인내가 여기에 있다.\n그들은 하나님의 계명들과\n예수에 대한 믿음을 지키는 사람들이다.",
      "address": "계 14:12"
    }
]
// 그분의 사랑의 언약을 천대까지 지키시는
// 이 뽕나무에게 '뿌리째 뽑혀 바다에 심겨라!'라고 하면
export default RHEMAS